import { render, staticRenderFns } from "./commissionReview.vue?vue&type=template&id=4ddb4670&scoped=true"
import script from "./commissionReview.vue?vue&type=script&lang=js"
export * from "./commissionReview.vue?vue&type=script&lang=js"
import style0 from "./commissionReview.vue?vue&type=style&index=0&id=4ddb4670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb4670",
  null
  
)

export default component.exports